module.exports = __webpack_public_path__ + "static/media/timetable-menu-item.48e395a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/timetable-menu-item.svg
// module id = 172
// module chunks = 0